const isChineseEnv =
  import.meta.env.REACT_APP_MANAGEMENT_URL === 'https://admin.genesysonline.cn' ||
  window?._env_?.REACT_APP_REGION === 'cn';

export default isChineseEnv;
